import api from '~/services/api';
import { JSONAPIAddress } from '~/types/APIAddress';

export function getApiAddresses() {
  return api.request<{ results: JSONAPIAddress[] }>({
    url: '/ui/user_addresses',
    method: 'GET',
    params: {
      results: 100,
    },
  });
}

export function createApiAddress(address: JSONAPIAddress) {
  return api.request<JSONAPIAddress>({
    url: '/ui/user_addresses',
    method: 'POST',
    data: {
      ...address,
      hard_validate: true, // Enforces hard validation on City/State/Zip fields
    },
  });
}

export function editApiAddress(id: string | number, address: JSONAPIAddress) {
  return api.request<JSONAPIAddress>({
    url: `/ui/user_addresses/${id}`,
    method: 'PUT',
    data: {
      ...address,
      hard_validate: true, // Enforces hard validation on City/State/Zip fields
    },
  });
}

export function deleteApiAddress(id: string | number) {
  return api.request({
    url: `/ui/user_addresses/${id}`,
    method: 'DELETE',
  });
}
